import type { IconDefinition } from '@fortawesome/free-brands-svg-icons';
import { faGoogle, faMeta } from '@fortawesome/free-brands-svg-icons';
import {
  faArrowProgress,
  faAt,
  faAtlas,
  faBrowser,
  faBullseyePointer,
  faCommentDots,
  faEnvelope,
  faEnvelopeOpenText,
  faMapMarkerAlt,
  faMindShare,
  faRedo,
  faReplyAll,
  faSearch,
  faUsers,
  faWandMagicSparkles,
} from '@fortawesome/pro-regular-svg-icons';

import { CampaignClass, CampaignState } from '@feathr/blackbox';
import { EFontAwesomeKitIcon } from '@feathr/components';

export const campaignColorMap = new Map<CampaignClass, string>([
  [CampaignClass.Segment, 'sky'],
  [CampaignClass.Lookalike, 'yellow'],
  [CampaignClass.SeedSegment, 'yellow'],
  [CampaignClass.Affinity, 'orange'],
  [CampaignClass.Search, 'orange'],
  [CampaignClass.EmailList, 'red'],
  [CampaignClass.MobileGeoFencing, 'indigo'],
  // TODO: Set color for MobileGeoFenceRetargeting
  [CampaignClass.MobileGeoFenceRetargeting, 'indigo'],
  [CampaignClass.Referral, 'teal'],
  [CampaignClass.Conversation, 'blue'],
  [CampaignClass.LandingPage, 'green'],
  [CampaignClass.Facebook, 'sky'],
  [CampaignClass.EmailListFacebook, 'red'],
  [CampaignClass.TrackedLink, 'red'],
  [CampaignClass.PinpointEmail, 'yellow'],
  [CampaignClass.SmartPinpointEmail, 'yellow'],
  [CampaignClass.AutoPinpointEmail, 'yellow'],
  [CampaignClass.GoogleAdsSmart, 'sky'],
  // TODO: Set correct color for Drip and DripStep
  [CampaignClass.Drip, 'yellow'],
  [CampaignClass.DripStep, 'yellow'],
  [CampaignClass.Omni, 'sky'],
]);

export const campaignStateColorMap = new Map<CampaignState, string>([
  [CampaignState.Draft, 'default'],
  [CampaignState.Stopped, 'red'],
  [CampaignState.Erroring, 'orange'],
  [CampaignState.Published, 'green'],
  [CampaignState.Publishing, 'sky'],
  [CampaignState.Archived, 'default'],
]);

export const campaignIconMap = new Map<CampaignClass, IconDefinition>([
  [CampaignClass.Segment, faRedo],
  [CampaignClass.Lookalike, faUsers],
  [CampaignClass.SeedSegment, faUsers],
  [CampaignClass.Affinity, faWandMagicSparkles],
  [CampaignClass.Search, faSearch],
  [CampaignClass.EmailList, faAt],
  [CampaignClass.MobileGeoFencing, faMapMarkerAlt],
  [CampaignClass.MobileGeoFenceRetargeting, faAtlas],
  [CampaignClass.Referral, faEnvelope],
  [CampaignClass.Conversation, faCommentDots],
  [CampaignClass.LandingPage, faBrowser],
  [CampaignClass.GoogleAdsSmart, faGoogle],
  [CampaignClass.Facebook, faMeta],
  [CampaignClass.EmailListFacebook, faMeta],
  [CampaignClass.TrackedLink, faBullseyePointer],
  [CampaignClass.PinpointEmail, faEnvelopeOpenText],
  [CampaignClass.SmartPinpointEmail, faMindShare],
  [CampaignClass.AutoPinpointEmail, faReplyAll],
  // TODO: Set correct icon for Drip and DripStep
  [CampaignClass.Drip, faArrowProgress],
  [CampaignClass.DripStep, faArrowProgress],
]);

export const customCampaignIconMap = new Map<CampaignClass, EFontAwesomeKitIcon>([
  [CampaignClass.Omni, EFontAwesomeKitIcon.pixlPlus],
]);
